import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import {
  getSavingsInputFields,
  housingFundsInputList,
  ntsTypeOptions,
  savingCategoryOptions,
} from '../../../common/data';
import { formatNumber } from '../../../common/Util';

import ItemTitleSection from '../../../components/ItemTitleSection';
import TextField from '../../../components/common/TextField';

import Typography from '../../../components/common/Typography';
import { getBankList } from '../../common/commonSlice';

const Type3 = ({ onOpen }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation('deductions/housingFunds');
  const { t: tCommon } = useTranslation('common');
  const ntsTypeList = ntsTypeOptions(tCommon);
  const { s10_2Data } = useSelector(state => state.housingFunds);
  const inputFields = getSavingsInputFields(t);
  const savingCategoryList = savingCategoryOptions(t);
  const { bankList } = useSelector(state => state.common);

  useEffect(() => {
    if (bankList.length === 0) {
      dispatch(getBankList());
    }
  }, [bankList]);

  const renderField = (field, value) => {
    let fieldValue = field.isNumber ? formatNumber(value || '') : value?.trim() || '';
    //저축구분
    if (field.key === 'htm001') {
      const savingCategory = savingCategoryList.find(item => item.value === value);
      fieldValue = savingCategory?.label;
    }

    //국세청구분
    if (field.key === 'htmKFlag') {
      const ntsType = ntsTypeList.find(item => item.value === value);
      fieldValue = ntsType?.label;
    }

    //금융기관
    if (field.key === 'htm002') {
      const bank = bankList.find(item => item.bankCd?.trim() === value);
      fieldValue = bank?.bankNm;
    }
    return (
      <TextField label={field.label} value={fieldValue} onChange={() => {}} size="small" disabled />
    );
  };

  return (
    <div className="displayFlexColumn" style={{ gap: '16px' }}>
      <ItemTitleSection
        title={t('detail.title3')}
        addButton={true}
        handleAddButton={() => onOpen('type3', 'detail')}
      />

      {s10_2Data?.map((savings, index) => (
        <div key={index} className="savings-item">
          <div className="displayFlexBetween" style={{ marginBottom: '16px' }}>
            <Typography variant="body2Bold">
              {t('detail.title3')}
              {index + 1}
            </Typography>
          </div>

          <div className="displayFlexColumn" style={{ gap: '16px' }}>
            {inputFields.map((field, _index) => (
              <div key={_index}>{renderField(field, savings[field.key])}</div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Type3;
